import { render } from "./basic-accordion.vue?vue&type=template&id=3ec4a7a0"
import script from "./basic-accordion.vue?vue&type=script&lang=js"
export * from "./basic-accordion.vue?vue&type=script&lang=js"

import "./basic-accordion.vue?vue&type=style&index=0&id=3ec4a7a0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__